module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ShopActions":"Wrong?"},"de":{"ShopActions":"Falsch?"}}')
  delete Component.options._Ctor
}
